
/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 * authority: "https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/B2C_1_susi_reset_v2",
 * B2C_1_susi_reset_v2
 */
export const b2cPolicies = {
    loginUrl: 'https://login.microsoftonline.com',
    clientId: 'd3f851f2-6bc7-455b-8616-2cfc1b2f6d7c',
    tenantId: '1b16ab3e-b8f6-4fe3-9f3e-2db7fe549f6a'
};

/**
 * Enter here the coordinates of your web API and scopes for access token request
 * The current application coordinates were pre-registered in a B2C tenant.
 */
export const apiConfig: { scopes: string[] } = {
    scopes: [
        'd3f851f2-6bc7-455b-8616-2cfc1b2f6d7c/ac_user_access'
    ]
};
